
import DocumentFavorite from "../../../assets/filled/DocumentFavorite.svg";

import { IconProps } from "../../../types";

const cx = require('classnames');

export default function DocumentFavoriteIcon({ className, dataTestid = "DocumentFavoriteIcon", ...rest }: IconProps) {
  const classes = cx(className);

  return (
    <DocumentFavorite data-testid={dataTestid} className={classes} {...rest} />
  );
}
